export const APP_FADE_DURATION = 300;
export const FADE_IN_DURATION = 200;
export const CROSS_FADE_DURATION = 150;
export const SLIDE_DURATION = 190;



// WEBPACK FOOTER //
// ./src/constants/animation.js